import { render, staticRenderFns } from "./ViewFacility.vue?vue&type=template&id=70050d3d&scoped=true"
import script from "./ViewFacility.vue?vue&type=script&lang=js"
export * from "./ViewFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70050d3d",
  null
  
)

export default component.exports